import { Component, OnInit } from '@angular/core';

import { Bomba } from "../shared/bomba.model";
import { BombaNavigationService } from "../shared/bomba-navigation.service";
import { UtilService } from "../../../shared/services/util.service";
import { BombaApiService } from "../shared/bomba-api.service";
import { bombasModuleName } from "../shared/data.service";
import { BombaService } from "../shared/bomba.service";
import { AbastecimentoService } from "../../shared/abastecimento.service";
import { abastecimentosModuleName } from "../../shared/data.service";
import { configuracaoModuleName } from "../../../shared/services/data.service";

@Component({
    template: require('./bomba-list.component.html'),
    styles: [require('./bomba-list.component.css')]
})
export class BombaListComponent implements OnInit {
    list: Bomba[] = [];
    loading: boolean = true;
    showDisabled: boolean = false;
    bombaModule: any = bombasModuleName;
    module: any = abastecimentosModuleName;
    configuracaoModule: any = configuracaoModuleName;

    constructor(
        private _bombaNavigationService: BombaNavigationService,
        private _bombasApiService: BombaApiService,
        private _bombasService: BombaService,
        private _utilService: UtilService,
        private _abastecimentoService: AbastecimentoService
    ) { }

    ngOnInit() {
        this.getAll();
    }

    clickNew() {
        this._bombasService.clearSessionStorage();
        this._bombaNavigationService.goToNew();
    }

    clickGoToSettings() {
        this._abastecimentoService.goToSetting();
    }

    clickEdit(item: Bomba) {
        this._bombasService.clearSessionStorage();
        this._bombaNavigationService.goToEdit(item.id);
    }

    clickDelete(item: Bomba) {
        let onDelete = (function() {
            this.onDelete(item);
        }.bind(this));

        this._utilService.swalMessageDelete(onDelete);
    }

    private getAll() {
        let onDone = (function(Response: any) {
            if (!Response.error)  {
                this.list = Response;
            }
            this.loading = false;
        }.bind(this));

        this._bombasApiService.onGetAll(onDone);
    }

    private onDelete(item: any) {
        let onDone = (function(Response: any) {
            if (!Response.error) {
                let x: number, lenX: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    if (this.list[x].id === item.id) {
                        this.list[x].ativo = false;
                        break;
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        this._bombasApiService.onDelete(item.id, onDone);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bomba-list/bomba-list.component.ts
 **/